import dayjs from 'dayjs'
import React, { useContext, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { ConsumptionDataContext } from '../../../contexts/ConsumptionDataContext'
import useUser from '../../../contexts/hooks/useUser'
import { useSolarPanel } from '../../devices/solarPanel/hooks/useSolarPanel'
import CircleCarousel from './circles/CircleCarousel'
import PreviousCard from './previousCards/PreviousCard'

export type MainPagePanelView = 'nature' | 'consumption' | 'money' | 'production'

const MainView: React.FC = () => {
	const { consumptionData } = useContext(ConsumptionDataContext)

	const { user } = useUser()

	const history = useHistory()

	const { consideredMonth, comparisonMonth } = consumptionData

	const [activeView, setActiveView] = useState<MainPagePanelView>('money')

	const inverter = user?.panelLinked
		? useSolarPanel({
				span: 'month',
				startTime: dayjs().startOf('month'),
				endTime: dayjs().endOf('month'),
			})
		: undefined

	return (
		<>
			<CircleCarousel
				comparisonMonth={comparisonMonth}
				consideredMonth={consideredMonth}
				inverter={user?.panelLinked ? inverter : undefined}
				history={history}
				activeElement={activeView}
				setActiveElement={setActiveView}
			/>

			<div className='w-full z-0' style={{ marginTop: 'calc(-9.5rem)' }}>
				<div
					className='mx-auto h-[30px] -mb-[1px] bg-white dark:bg-[#0d2d30]'
					style={{
						width: 'calc(100% - 14px)',
						clipPath: 'polygon(0 100%, 100% 100%, 50% 0)',
					}}
				/>

				<PreviousCard
					consumptionData={consumptionData}
					inverter={user?.panelLinked ? inverter : undefined}
					activeView={activeView}
				/>
			</div>
		</>
	)
}

export default MainView
